module.exports = __webpack_public_path__ + "img/ava1.346ac6d0.png";